<template>
  <div>
    <LandingPageBody v-bind="landingPageProps" />
  </div>
</template>

<script>
import LandingPageBody from '@/components/CampaignLandingPage/LandingPageBody'
import { CountryCodes } from '@/enums/general'
import { LandingPageType } from '@/enums/landing'
import { MembershipTypes } from '@/enums/member'
import { AUTH_ID, AUTH_USER } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AddSocksRegularLandingPage',
  layout: 'homepage-signup-button',
  components: {
    LandingPageBody
  },
  computed: {
    landingPageProps () {
      return {
        locizePath: 'LandingPage.AddSocksRegular',
        imagePath: '/images/frontend/socks/',
        appCountry: this.country,
        locale: this.locale,
        userIdentifier: this.userId,
        landingpageUrl: '/add-socks-regular',
        primaryColor: '#A0814B',
        type: LandingPageType.addMembership,
        authUser: this.authUser,
        membershipTypeReference: MembershipTypes.socksRegular,
        getSizeOptions: this.getSizeOptions
      }
    },
    sizeOptions () {
      return [
        {
          value: 'originals-socks-regular-39-42',
          label: '39-42'
        },
        {
          value: 'originals-socks-regular-43-46',
          label: '43-46'
        }
      ]
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('auth', {
      userId: AUTH_ID,
      authUser: AUTH_USER
    })
  },
  methods: {
    getSizeOptions ({ country } = {}) {
      if (country === CountryCodes.unitedKingdom) {
        return [
          {
            value: 'originals-socks-regular-39-42',
            label: '6-8'
          },
          {
            value: 'originals-socks-regular-43-46',
            label: '9-11'
          }
        ]
      }

      return this.sizeOptions
    }
  }
}
</script>

<style>

</style>
